/* Asse Lab · cinematic homepage behaviours: reveals, counters, tilt, scroll-linked progress, book flip, sticky bar. */
(function () {
  if (window.__asseCine) return;
  window.__asseCine = true;
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var noHover = window.matchMedia('(hover: none)').matches;

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* counters */
  function count(el) {
    var to = parseFloat(el.getAttribute('data-count'));
    if (isNaN(to) || rm || to === 0) { el.textContent = el.getAttribute('data-count'); return; }
    var t0 = performance.now(), dur = 1700;
    el.textContent = '0';
    (function f(t) {
      var k = clamp((t - t0) / dur, 0, 1), e = 1 - Math.pow(1 - k, 3);
      el.textContent = Math.round(to * e);
      if (k < 1) requestAnimationFrame(f);
    })(t0);
  }

  /* reveals */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      el.classList.add('is-in');
      if (el.hasAttribute('data-count')) count(el);
      io.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;

  /* hero title word split (keeps the same text for SEO) */
  function split(el) {
    if (el.__split || rm) return; el.__split = true;
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var w = document.createElement('span'); w.className = 'w';
            var s = document.createElement('span'); s.textContent = p; s.style.setProperty('--i', i++);
            w.appendChild(s); frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1) walk(n);
      });
    })(el);
    el.classList.add('is-split');
  }

  /* tilt */
  function tilt(el) {
    if (el.__tilt || rm || noHover) return; el.__tilt = true;
    var s = parseFloat(el.getAttribute('data-tilt')) || 8;
    var host = el.closest('[data-tilt-host]') || el;
    host.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      el.style.setProperty('--rx', (-y * s).toFixed(2) + 'deg');
      el.style.setProperty('--ry', (x * s).toFixed(2) + 'deg');
      el.style.setProperty('--mx', ((x + 0.5) * 100).toFixed(1) + '%');
      el.style.setProperty('--my', ((y + 0.5) * 100).toFixed(1) + '%');
    });
    host.addEventListener('pointerleave', function () {
      el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg');
    });
  }

  /* scroll-linked elements */
  var linked = [];
  function progress(el, r, vh) {
    var mode = el.getAttribute('data-scroll');
    if (mode === 'pin') return (-r.top) / Math.max(1, r.height - vh);
    if (mode === 'through') return (vh * 0.85 - r.top) / (vh * 0.6);
    return (vh - r.top) / (vh + r.height);
  }
  var ticking = false;
  function update() {
    ticking = false;
    var vh = window.innerHeight;
    linked.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return;
      var p = clamp(progress(el, r, vh), 0, 1);
      if (el.__p === p) return; el.__p = p;
      el.style.setProperty('--p', p.toFixed(4));
      if (el.__onp) el.__onp(p);
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  /* book */
  function book(el) {
    if (el.__book) return; el.__book = true;
    var leaves = Array.prototype.slice.call(el.querySelectorAll('.cine-book__leaf'));
    var caps = Array.prototype.slice.call(el.querySelectorAll('[data-cap]'));
    var bar = el.querySelector('.cine-book__bar i');
    var n = leaves.length;
    el.__onp = function (p) {
      var v = p * (n + 0.5) - 0.2;
      leaves.forEach(function (lf, i) {
        var k = clamp(v - i, 0, 1);
        var e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        lf.style.transform = 'rotateY(' + (-180 * e).toFixed(2) + 'deg)';
        lf.style.zIndex = k > 0.5 ? (10 + i) : (10 + n - i);
      });
      el.style.setProperty('--open', clamp(v * 1.6, 0, 1).toFixed(4));
      var idx = clamp(Math.round(v), 0, n);
      caps.forEach(function (c, i) { c.classList.toggle('is-on', i === idx); });
      if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    };
    el.__onp(0);
  }

  /* sticky buy bar */
  function bar() {
    var b = document.querySelector('[data-cine-bar]');
    if (!b || b.__bar || !io) return; b.__bar = true;
    var hide = Array.prototype.slice.call(document.querySelectorAll('[data-bar-hide]'));
    var seen = new Map();
    var o = new IntersectionObserver(function (es) {
      es.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
      var any = false; seen.forEach(function (v) { if (v) any = true; });
      b.classList.toggle('is-on', !any);
      b.setAttribute('aria-hidden', any ? 'true' : 'false');
    }, { threshold: 0 });
    hide.forEach(function (h) { o.observe(h); });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-split]').forEach(split);
    root.querySelectorAll('[data-reveal], [data-count]').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
    root.querySelectorAll('[data-tilt]').forEach(tilt);
    root.querySelectorAll('[data-book]').forEach(book);
    root.querySelectorAll('[data-scroll]').forEach(function (el) { if (linked.indexOf(el) < 0) linked.push(el); });
    root.querySelectorAll('video[data-autoplay]').forEach(function (v) {
      if (rm) { v.removeAttribute('autoplay'); v.pause(); return; }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
    bar();
    update();
  }

  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  window.addEventListener('resize', onScroll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
